export default "__VITE_ASSET__32874b5d__"